document.addEventListener('DOMContentLoaded', function () {
    function updateProductReviewStatus() {
        var products = document.querySelectorAll('.product')
        products.forEach(function (product) {
            var reviewStatusMeta = product.querySelector('.product-review-status')
            if (reviewStatusMeta) {
                var isReviewEnabled = reviewStatusMeta.getAttribute('data-review-enabled') === 'true'
                if (!isReviewEnabled) {
                    product.classList.add('reviews-disabled')
                }
            }
        })
    }

    // Initial load
    updateProductReviewStatus()

    // FacetWP events
    document.addEventListener('facetwp-loaded', updateProductReviewStatus)
})
